import PropTypes from 'prop-types';
import ScreenReaderOnly from '../../../UI/ScreenReaderOnly/ScreenReaderOnly';
import BasketItemImage from '../../../v2/components/BasketItemImage/BasketItemImage';
import fastTrackLogo from '../../../v2/components/ui/svg/fastTrackLogo.svg';
import Translation from '../../../v2/lang/Translation';

import './DeliveryOptionProductList.scss';

export function DeliveryOptionProductList(props) {
  const title = props.item.productTitle || props.item.title;

  return (
    <li
      id={`DeliveryOptionProductList-${props.index}`}
      className="DeliveryOptionProductList"
    >
      <div className={`DeliveryOptionProductList__image${props.isRectangle ? '--rectangle' : ''}`}>
        <BasketItemImage
          key={props.index}
          productUrl={props.item.productImage}
          quantity={props.item.quantity}
          title={props.item.title}
        />
      </div>
      <div className="DeliveryOptionProductList-info">
        {props.item.fastDelivery && (
          <div className="DeliveryOptionList__fastTrackAvailable">
            <img
              className="DeliveryOptionList__modalLogo"
              src={fastTrackLogo}
              alt="Fast Track Logo"
              title={Translation.getText('fastDelivery.logo')}
            />
            <Translation>fastDelivery.available.message</Translation>
          </div>
        )}
        <p className="DeliveryOptionProductList-title">{title}</p>
        <ScreenReaderOnly>
          <Translation placeholderValues={[props.item.quantity]}>
            quantity
          </Translation>
        </ScreenReaderOnly>
      </div>
    </li>
  );
}

DeliveryOptionProductList.propTypes = {
  item: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    quantity: PropTypes.number,
    productImage: PropTypes.string,
    shippable: PropTypes.bool,
    fastDelivery: PropTypes.bool,
  })).isRequired,
  index: PropTypes.number.isRequired,
  isRectangle: PropTypes.bool,
};

export default DeliveryOptionProductList;
